import React from 'react';
import { cn } from '../../lib/utils';

/**
 * Single fixed-width main chain column for trigger row, action steps, and end node.
 * Branch graphs render downstream inside step list and must not widen this layer.
 */
const WorkflowBuilderMainChain = ({
  width,
  wrapperWidth = null,
  offset = 0,
  centerX = null,
  globalCenterX = null,
  className,
  children,
}) => {
  const resolvedWrapperWidth = wrapperWidth ?? width;
  const resolvedGlobalCenterX = globalCenterX ?? centerX;

  return (
    <div
      className={cn('relative mx-auto shrink-0', className)}
      style={{
        width: resolvedWrapperWidth,
        marginLeft: offset,
      }}
      data-workflow-main-chain-layer
      data-workflow-main-chain-width={width}
      data-workflow-main-chain-offset={offset}
      data-workflow-main-lane-x={resolvedGlobalCenterX ?? undefined}
      data-workflow-main-global-center-x={resolvedGlobalCenterX ?? undefined}
    >
      {children}
    </div>
  );
};

export default WorkflowBuilderMainChain;
